export default "__VITE_ASSET__pD1Gaq1I__"